import { Keyboard, Platform, Pressable, StyleSheet, Text, View } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { BackHandler, ActivityIndicator } from "react-native";
import { validateCPhone, validateEmail, validateUserName } from "../../utils/CommonUtils";
import { AuthNavProps } from "../navigation/auth/AuthParamList";
import {
    login,
    checkAcApi,
    register,
    sendVerifyCode,
    checkVerifyCode,
} from "../../net/service";
import { LoginRequestData } from "../../net/request";
import { showDialog, showMsgDialog } from "../../components/CommonDialog";
import { white, black, color_main, ColorF6F6F6, Color71717A, Color43C6A7 } from "../../assets/style/colors";
import { setEncrypt, setMsgAssistant, setMsgTranslate, setSecret, setServiceUrl, setToken, setUid, setVcode } from "../../store/token";
import { useStore } from "../../store/UserStore";
import { cleanSchema } from "../../realm";
import * as ImSdk from "../../../imsdk/api/index";
import { hideLoading, showLoading } from "../../components/Loading";

import {
    Str_AccNotNull,
    Str_AlreadyNotRegistered,
    Str_And,
    Str_CodeAlreadySend,
    Str_CodeSendFail,
    Str_CurrenAccInUse,
    Str_Err1015,
    Str_InputAcc2,
    Str_InputCode,
    Str_InputPsd,
    Str_InputTelno,
    Str_LoginRegister,
    Str_PhoneNotNull,
    Str_PrivacyPolicy,
    Str_PsdLengthErr1,
    Str_PsdLengthErr2,
    Str_ReadAgreed,
    Str_ReadAgreedTip,
    Str_ReSend,
    Str_SendCode,
    Str_UserAgreement,
    Str_RegisterSuc,
    Str_RegisterFail,
    Str_PsdNotEmpty,
    Str_PsdFormatErr,
    Str_enterCaptcha,
    Str_captchaError,
    Str_unknownError,
    Str_NoSpacesAllowed,
    Str_Account,
    Str_Psd,
    Str_ForgotPsd,
    Str_Code,
    Str_Register,
    Str_InputPsdAgain,
    Str_PasswordCannotBeSame,
    Str_PsdInconsistent,
    Str_ConfirmPsd,
    Str_AlreadyUsed,
    Str_Email,
    Str_Phone,
} from "../../language/string_res";
import { CryptEngine } from "../../utils/CryptEngine";
import { showToast } from "../../components/Toast";
import DeviceInfo from "react-native-device-info";
import { getLanguage } from "../../language/i18n";
import { Checkbox, CheckboxHandle } from "../../components/Checkbox";
import DebounceButton from "../DebounceButton";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import { CommonInput } from "./CommonInput";
import { NickGuideModal } from "./NickGuideModal";
import { CaptchaResponse } from "../../net/response";
import { ImageView } from "../../components/ImageView";
import { validatePassword } from "./register";
import { countryCodeManager } from "../CountryCodeSelete";
import Logo from "../../assets/svg/ic_round_logo.svg";
import MisoLogo from "../../assets/svg/ic_round_logo_miso.svg";
import { LoginInput } from "./LoginInput";
import UserIcon from "../../assets/svg/icon_user.svg";
import PsdIcon from "../../assets/svg/icon_psd.svg";
import HideIcon from "../../assets/svg/icon_eye.svg";
import DisplayleIcon from "../../assets/svg/icon_close_eye.svg";
import SafetyIcon from "../../assets/svg/ic_safety.svg";
import { ChangeLanguageModal } from "../setting/other_setting";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Network from "../../assets/svg/ic_network.svg";
import { isIOS } from "../../utils/utils";
import globalEventBus from "../../utils/EventBus";
import { BehavioralVerifyCallbackType, BehavioralVerifyModal } from "./BehavioralVerifyModal";
import { isMiso } from "../../../imsdk/api/index";

const totalSeconds = 60;
const KeyLoginInfo = "KeyLoginInfo";
type TypeLoginInfo = {
    vcode: string;
    account: string;
    pwd: string;
    countryCode: string;
    accountType: AccountType;
};
type AccountType = "email" | "username" | "phone";
export const LoginRegister = ({ navigation, route }: AuthNavProps<"Login">) => {
    // 在组件内部获取 ImSdk 实例，避免顶层初始化问题
    const im = ImSdk.getInstance();
    const [showPassword, setShowPassword] = useState(false);
    const [account, setAccount] = useState("");
    const [registerAccount, setRegisterAccount] = useState("");
    const [psd, setPsd] = useState("");
    const [registerPsd, setRegisterPsd] = useState("");
    const [code, setCode] = useState("");
    const [countryCode, setCountryCode] = useState("+86");
    const [accountType, setAccountType] = useState<AccountType>("username");
    const { dispatch, state } = useStore();
    const vcode = route?.params?.vcode ?? "";
    const isAddAccount = route?.params?.isAddAccount ?? false;
    const lastUid = route?.params?.lastUid ?? 0;
    const [confirmPwd, setConfirmPwd] = useState("");
    const [sendText, setSendText] = useState(Str_SendCode);
    const [running, setRunning] = useState(false);
    const timeoutRef = useRef<number | null>(null);
    const remainRef = useRef<number>(totalSeconds);
    const mLoginData = useRef<any>(undefined);
    const isFirst = useRef<boolean>(false);
    const lastAccount = useRef<string>(); //用来记录上次登录的账号
    const isLogin = useRef(false);
    const checkBoxRef = useRef<CheckboxHandle>(null);
    const rememberBoxRef = useRef<CheckboxHandle>(null);
    const [nickGuideVisible, setNickGuideVisible] = useState(false);
    const [deviceId, setDeviceId] = useState("");
    const [isRegister, setRegister] = useState(false);
    const language = getLanguage();
    const isFocused = useIsFocused();
    const [busy, setBusy] = useState(false); // 全局忙碌状态
    const [langVisible, setLangVisible] = useState(false);
    const insets = useSafeAreaInsets();
    const lang = getLanguage()
    const eventTagRef = useRef("")
    const [isVerifyModalShow, setIsVerifyModalShow] = useState(false)
    const captchaToken = useRef<string>("")
    const onBehavioralVerifyBlack = useRef<BehavioralVerifyCallbackType | undefined>(undefined)

    // 忙碌态时拦截 Android 实体返回键
    useEffect(() => {
        const onBack = () => {
            if (busy) return true; // 忙碌时吃掉返回
            return false;
        };
        if (busy) {
            BackHandler.addEventListener("hardwareBackPress", onBack);
        }
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", onBack);
        };
    }, [busy]);

    useEffect(() => {
        DeviceInfo.getUniqueId().then(setDeviceId);
        countryCodeManager.setListener?.(setCountryCode);
        return () => {
            countryCodeManager.removeListener();
        };
    }, []);

    useEffect(() => {
        if (!isFocused) {
            return;
        }

        if (isLogin) {
            return
        }

        mLoginData.current = undefined;
        if (!isFirst.current) {
            isFirst.current = true;
            AsyncStorage.getItem(KeyLoginInfo).then((res) => {
                if (res && res.length > 0) {
                    const info: TypeLoginInfo = JSON.parse(res);
                    if (info.vcode !== vcode) {
                        return;
                    }
                    setAccount(info.account);
                    setPsd(info.pwd);
                    setCountryCode(info.countryCode);
                    setAccountType(info.accountType);
                    if (info.pwd?.length > 0) {
                        rememberBoxRef.current?.changeChecked(true);
                    }
                } else {
                    const code = language;
                    let countryCode = "+86";
                    if (code === "es") {
                        countryCode = "+34";
                    } else if (code === "ja") {
                        countryCode = "+81";
                    } else if (code === "vi") {
                        countryCode = "+84";
                    } else if (code === "pt") {
                        countryCode = "+351";
                    } else if (code === "en") {
                        countryCode = "+1";
                    }
                    setCountryCode(countryCode);
                }
            });
        }
    }, [isFocused]);

    useEffect(() => {
        if (checkBoxRef.current) {
            checkBoxRef.current.changeChecked(true);
        }
        return () => {
            if (timeoutRef.current) {
                clearInterval(timeoutRef.current as unknown as number);
                timeoutRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        const type = getAccountType(isRegister ? registerAccount : account);
        setAccountType(type);
    }, [account, registerAccount,isRegister]);

    // 将 raw 规范化为 RN 可用的 uri
    const normalizeCaptchaRaw = (raw?: string): string | undefined => {
        if (!raw) return undefined;
        if (raw === "null") return undefined;
        if (raw.startsWith("http") || raw.startsWith("data:")) {
            return raw; // 已是完整 url 或 data-uri
        }
        return `data:image/png;base64,${raw}`;
    };

    function getAccountType(input?: string): AccountType {
        const trimmed = (input ?? "").trim();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return "email";
        if (/^\d+$/.test(trimmed)) return "phone";
        return "username";
    }

    function startTime() {
        if (running || timeoutRef.current) return;
        setRunning(true);
        remainRef.current = totalSeconds;
        setSendText(`${remainRef.current}s`);
        timeoutRef.current = setInterval(() => {
            remainRef.current -= 1;
            if (remainRef.current <= 0) {
                reset();
            } else {
                setSendText(`${remainRef.current}s`);
            }
        }, 1000) as unknown as number;
    }

    function reset() {
        setSendText(Str_ReSend);
        setRunning(false);
        if (timeoutRef.current) {
            clearInterval(timeoutRef.current as unknown as number);
            timeoutRef.current = null;
        }
    }

    function registerSendCode() {
        if (running) return;
        let acc = isRegister ? registerAccount : account;
        if (!acc.trim()) {
            showToast(accountType === "phone" ? Str_PhoneNotNull : Str_AccNotNull);
            return;
        }
        if (accountType === "phone" && !/^\d+$/.test(acc.trim())) {
            showToast(Str_InputTelno);
            return;
        }

        onBehavioralVerifyBlack.current = onSendCodeBehavioralVerifySuccess
        setIsVerifyModalShow(true)
    }

    const onSendCodeBehavioralVerifySuccess = async (isSuccess: boolean, token: string) => {
        // 验证未通过
        if (!isSuccess) {
            return
        }

        captchaToken.current = token

        let acc = isRegister ? registerAccount : account;
        if (accountType === "phone") {
            acc = `${countryCode}-${acc}`;
        }

        checkAccountAndSendCode(acc, "10")
    }

    // 检查账号并且发送验证码
    function checkAccountAndSendCode(acc: string, send_type: string) {
        // 先校验账号,获取EventTag
        checkAcApi({ account: acc, vcode: vcode, lang: lang }).then((res) => {
            if (res.code === 0) {
                // 如果是注册, 账号必须不存在
                if (res.data?.exist === true) {
                    showToast(res.msg || ((accountType === "phone" ? Str_Phone : Str_Email) + Str_AlreadyUsed))
                    reset()
                    return;
                }

                // 存在
                const eventTag = res.data.eventTag
                eventTagRef.current = eventTag

                startTime()
                // 发送手机验证码
                sendVerifyCode({
                    send_type: send_type,
                    eventTag: eventTag,
                    lang: lang,
                    vcode: vcode,
                    captchaToken: captchaToken.current,
                    byEmail: accountType === "email"
                }).then(res => {
                    if (res.code === 0) {
                        showToast(Str_CodeAlreadySend)
                    } else {
                        showToast(res.msg || Str_CodeSendFail)
                        reset()
                        console.log(`${JSON.stringify(res)}`)
                    }
                })
            } else {
                showToast(res.msg || Str_CodeSendFail)
                reset()
            }
        }).catch((res) => {
            showToast(res.msg || Str_CodeSendFail)
            reset()
        })
    }

    const registerNewUser = async () => {
        const acc = isRegister ? registerAccount : account;
        const pwd = isRegister ? registerPsd : psd;
        // 本地构造 comboAccount，避免依赖外部 state 时序
        const localCombo = accountType === "phone" ? `${countryCode}-${acc}` : acc;
        //TODO: captchaToken.current 后期可能增加这个参数
        const params: any = {
            deviceId: deviceId,
            lang: language,
            vcode: vcode,
            aggrement: true,
            account: localCombo,
            passwd: CryptEngine.md5(pwd.trim()).toLowerCase(),
        };

        if (accountType !== "username") {
            const r: any = await checkVerifyCode({
                send_type: "10",
                code,
                lang: language,
                vcode,
                eventTag: eventTagRef.current
            })

            if (r.code !== 0 || !r.data) {
                showToast(r.msg ?? Str_Err1015);
                isLogin.current = false;
                hideLoading();
                return;
            }

            params.sms_token = r.data.otp_token;
        }

        register(params)
            .then((data: any) => {
                hideLoading();
                console.log(`---> `, JSON.stringify(data))
                if (data.code !== 0) {
                    showMsgDialog(data.msg || Str_RegisterFail);
                    isLogin.current = false;
                    return;
                } else {
                    showDialog({
                        message: Str_RegisterSuc,
                        onConfirm: () => {
                            setBusy(true);
                            onAllowLogin(localCombo);
                            setConfirmPwd("");
                        },
                    });
                }
            })
            .catch(() => {
                hideLoading();
            });
    };

    // 忘记密码
    const ForgetPsd = () => {
        navigation.navigate("RetrievePsd", { vcode: vcode });
    };

    function initData() {
        // 如果登陆用户跟上一次的不是同一个，则清空数据
        return new Promise((resolve) => {
            const acc = isRegister ? registerAccount : account;
            if (!state?.user || acc !== state?.user?.telno) {
                cleanSchema();
                dispatch({ type: "INIT_STORE_DATA" });
            }
            resolve(true);
        });
    }

    const onCheckAcExist = async (comboAccount: string): Promise<boolean> => {
        const res = await checkAcApi({
            account: comboAccount,
            vcode,
            lang: language,
        });
        if (res.code === 0 && res.data?.exist === true) {
            // 存在
            return true;
        } else {
            // 不存在
            reset();
            showToast(res.msg || Str_AlreadyNotRegistered);
            return false;
        }
    };

    function checkForm(): boolean {
        // 协议勾选校验
        const isChecked = checkBoxRef.current?.isChecked() ?? false;
        if (!isChecked) {
            showToast(Str_ReadAgreedTip);
            return false;
        }

        const acc = isRegister ? registerAccount : account;
        const pwd = isRegister ? registerPsd : psd;
        // 基本表单校验
        if (acc.trim().length === 0) {
            showToast(Str_AccNotNull);
            return false;
        }

        if (accountType === "phone") {
            const msg = validateCPhone(acc);
            if (msg) {
                showToast(msg);
                return false;
            }
        }

        if (accountType === "email") {
            const msg = validateEmail(acc);
            if (msg) {
                showToast(msg);
                return false;
            }
        }

        if (accountType === "username") {
            const msg = validateUserName(acc);
            if (msg) {
                showToast(msg);
                return false;
            }
        }

        if (pwd.trim().length === 0) {
            showToast(Str_PsdNotEmpty);
            return false;
        }

        if (pwd.trim().length < 8) {
            showToast(Str_PsdLengthErr1);
            return false;
        }
        if (!validatePassword(pwd)) {
            showToast(Str_PsdFormatErr);
            return false;
        }
        if (pwd.trim().length > 32) {
            showToast(Str_PsdLengthErr2);
            return false;
        }
        if (isRegister) {
            if (!confirmPwd || confirmPwd !== pwd) {
                showToast(Str_PsdInconsistent);
                return false;
            }

            if (accountType === "username") {
                if (!confirmPwd || confirmPwd !== pwd) {
                    showToast(Str_PsdInconsistent);
                    isLogin.current = false;
                    return false;
                }
            } else {
                if (!code || code.length === 0) {
                    isLogin.current = false;
                    showToast(Str_InputCode);
                    return false;
                }
            }
        }

        return true
    }

    const Login = async () => {
        if (isLogin.current) return;
        isLogin.current = true;

        if (checkForm() !== true) {
            isLogin.current = false;
            return
        }

        if (accountType === "username") {
            onBehavioralVerifyBlack.current = onBehavioralVerifySuccess
            // 显示图片验证码
            setIsVerifyModalShow(true)
        } else {
            // 短信和邮箱已经在
            onBehavioralVerifySuccess(true, captchaToken.current)
        }
    };

    const onBehavioralVerifySuccess = async (isSuccess: boolean, token: string) => {
        // 验证未通过
        if (!isSuccess) {
            isLogin.current = false;
            return
        }

        captchaToken.current = token
        setBusy(true);
        showLoading(isRegister ? "正在注册..." : "正在登录...");

        try {
            const acc = isRegister ? registerAccount : account;
            const combo = accountType === "phone" ? `${countryCode}-${acc}` : acc;

            // 若需注册则先执行注册逻辑
            if (isRegister) {
                await registerNewUser(); // 内部已有提示
                return;
            }

            // 检查账号是否存在，不存在则切入注册流程
            const exist = await onCheckAcExist(combo);
            if (!exist) {
                hideLoading();
                return;
            }

            // 添加账号时校验当前账号是否已在用
            if (isAddAccount) {
                const [user, r] = await Promise.all([im.GetUserRemote(lastUid), im.getAuth(lastUid)]);
                const nowUser = user?.users?.[0];
                const currentCombo = accountType === "phone" ? `${countryCode}-${acc}` : acc;
                const isSameAccount = accountType === "phone" ? nowUser?.rtel === currentCombo : nowUser?.email === currentCombo;
                if (vcode === r.auth?.vcode && isSameAccount) {
                    hideLoading();
                    showToast(Str_CurrenAccInUse);
                    return;
                }
            }

            // 正式登录
            await onAllowLogin(combo);
        } catch (err: any) {
            console.error("Login error:", err);
            showToast(err?.msg || Str_unknownError);
        } finally {
            console.log("-----> Login finally");
            isLogin.current = false;
            hideLoading();
            setBusy(false);
        }
    }

    const onAllowLogin = async (comboAccount: string) => {
        return new Promise<void>((resolve, reject) => {
            //初始化数据
            initData().then(() => {
                const pwd = isRegister ? registerPsd : psd;
                const params: LoginRequestData = {
                    deviceId: deviceId,
                    lang: language,
                    vcode: vcode,
                    account: comboAccount,
                    passwd: CryptEngine.md5(pwd.trim()).toLowerCase(),
                };
                const value: TypeLoginInfo = {
                    vcode: vcode,
                    account: account,
                    pwd: "",
                    countryCode: countryCode,
                    accountType: accountType,
                };
                AsyncStorage.setItem(KeyLoginInfo, JSON.stringify(value));

                login(params)
                    .then(async (data: any) => {
                        console.log("-----> Login success:", data);
                        hideLoading();
                        if (!data || data.code !== 0) {
                            showToast(data?.msg ?? "");
                            isLogin.current = false;
                            lastAccount.current = comboAccount;
                            return reject(data);
                        }

                        // 重新拉取TabBar是否配置了Web
                        globalEventBus.emit("currentUserChanged", undefined);

                        mLoginData.current = data;
                        setUid(data.data.uid);
                        setToken(data.data.token);
                        setSecret(data.data.secret);
                        setEncrypt(data.data.encrypt);
                        setServiceUrl(data.data.customerServiceUrl);
                        setMsgAssistant(data.data.msgAssistant);
                        setMsgTranslate(data.data.msgTranslate);
                        setVcode(vcode);
                        try {
                            await checkNickGuide(data);
                            resolve();
                        } catch (e) {
                            reject(e);
                        }
                    })
                    .catch((e) => {
                        hideLoading();
                        reject(e);
                    });
            });
        });
    };
    const loginSuc = async () => {
        const data = mLoginData.current || {};
        const payload = {
            data: data.data!,
            syncUri: data.config?.syncUri || "",
        };
        const pwd = isRegister ? registerPsd : psd;
        if (rememberBoxRef?.current?.isChecked() === true) {
            const saveUserInfo = {
                vcode: vcode,
                account: account,
                pwd: pwd,
                countryCode: countryCode,
                accountType: accountType,
            };
            AsyncStorage.setItem(KeyLoginInfo, JSON.stringify(saveUserInfo));
        }
        const global_login = {
            uid: payload.data.uid,
            token: payload.data.token,
            appkey: payload.data.appkey,
            secret: payload.data.secret,
            encrypt: payload.data.encrypt,
            customerServiceUrl: payload.data.customerServiceUrl,
            msgAssistant: payload.data.msgAssistant,
            msgTranslate: payload.data.msgTranslate,
            vcode: vcode,
            isAddAccount: isAddAccount,
            lastUid: lastUid,
            switch_regist: payload.data.switch_regist || 0,
            switch_tab_main: payload.data.switch_tab_main || 0,
            switch_tab_mine: payload.data.switch_tab_mine || 1,
            switch_rtc: payload.data.switch_rtc || 0,
        };

        dispatch({
            type: "REPLACE_TOPIC_SUMMARY_LIST",
            payload: { top: [], normal: [] },
        });

        // 先本地切换并等待完成
        const authForSwitch = {
            uid: global_login.uid,
            token: global_login.token,
            appkey: global_login.appkey,
            vcode: global_login.vcode,
            customerServiceUrl: global_login.customerServiceUrl,
            secret: global_login.secret,
            encrypt: global_login.encrypt,
            msgAssistant: global_login.msgAssistant,
            msgTranslate: global_login.msgTranslate,
            switch_regist: global_login.switch_regist || 0,
            switch_tab_main: global_login.switch_tab_main || 0,
            switch_tab_mine: global_login.switch_tab_mine || 1,
            switch_rtc: global_login.switch_rtc || 0,
        } as const; // KKAuth形式

        try {
            await im.SwitchUser(authForSwitch);
        } catch (e) {
            console.warn("SwitchUser failed:", e);
        }

        // 切换完成后再同步给监听方
        im.global_emit("global_login", { global_login });

        // 设置 sync url
        // im.setBaseSyncUrl(payload.syncUri);
    };
    //校验是否需要展示引导
    const checkNickGuide = async (data: any) => {
        const nickGuide = data.config?.nickGuide || false;
        const loginGuide = data.config?.loginGuide || false;
        AsyncStorage.setItem(`${data.data.uid}-LoginGuide`, loginGuide ? "1" : "");
        dispatch({ type: "SET_LOGIN_GUIDE", payload: loginGuide });
        if (nickGuide) {
            setNickGuideVisible(true);
            return;
        }
        await loginSuc()
    }


    //用户协议
    const openAgreement = () => {
        const url =
            getLanguage() === "zh"
                ? "https://www.beebuzzchat.com/down/agreement.html"
                : "https://www.beebuzzchat.com/down/agreement_en.html";
        navigation.navigate("AuthCommonWeb", { url: url, showBack: true, title: Str_UserAgreement });
    };
    //隐私政策
    const openPrivacyPolicy = () => {
        const url =
            getLanguage() === "zh" ? "https://www.beebuzzchat.com/down/privacy.html" : "https://www.beebuzzchat.com/down/privacy_en.html";
        navigation.navigate("AuthCommonWeb", { url: url, showBack: true, title: Str_PrivacyPolicy });
    };

    function updateOperationType(isRegis: boolean) {
        setRegister(isRegis)
        const type = getAccountType(isRegis ? registerAccount : account);
        setAccountType(type);
        Keyboard.dismiss()
    }

    return (
        <View style={[styles.container, { backgroundColor: ColorF6F6F6 }]}>
            <View
                style={[styles.contentWrapper, { flex: 1, flexGrow: 1 }]}
            >
                <View style={{ flex: 1, flexDirection: "column", justifyContent: "center" }}>
                    <View
                        style={[
                            {
                                flex: 1,
                                alignItems: "center",
                                justifyContent: "center",
                                paddingHorizontal: 13,
                                paddingTop: insets.top,
                                paddingBottom: 20,
                            },
                            styles.contentContainer,
                        ]}
                        onStartShouldSetResponder={() => false}
                        onMoveShouldSetResponder={() => false}
                    >
                        {isMiso ? <MisoLogo width={80} height={80} /> : <Logo width={80} height={80} />}
                        <View
                            style={[
                                {
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    paddingHorizontal: 60,
                                    marginTop: 20,
                                    width: "100%",
                                },
                                styles.tabContainer,
                            ]}
                        >
                            <Pressable onPress={() => updateOperationType(false)} style={{ paddingHorizontal: 5 }}>
                                <Text style={[styles.tabText, { color: isRegister ? Color71717A : black }]}>{Str_LoginRegister}</Text>
                                <View style={{ backgroundColor: color_main, height: 8, marginTop: 2, opacity: isRegister ? 0 : 1 }} />
                            </Pressable>

                            <Pressable onPress={() => updateOperationType(true)} style={{ paddingHorizontal: 5 }}>
                                <Text style={[styles.tabText, { color: isRegister ? black : Color71717A }]}>{Str_Register}</Text>
                                <View style={{ backgroundColor: color_main, height: 8, marginTop: 2, opacity: isRegister ? 1 : 0 }} />
                            </Pressable>
                        </View>
                        <View
                            style={[
                                {
                                    backgroundColor: white,
                                    width: "100%",
                                    borderRadius: 20,
                                    paddingHorizontal: 16,
                                    paddingTop: 15,
                                    marginTop: 16,
                                },
                                styles.formContainer,
                            ]}
                        >
                            <LoginInput
                                label={Str_Account}
                                placeholder={Str_InputAcc2}
                                editable={!busy}
                                text={isRegister ? registerAccount : account}
                                source={<UserIcon />}
                                // sendText={accountType === 'phone' ? countryCode : undefined}
                                // sendCode={accountType === 'phone' ? () => navigation.navigate('AuthCountryCodeSelete') : undefined}
                                onChangeText={(text) => {
                                    const cleaned = text.replace(/[ 　]+/g, "");
                                    if (cleaned !== text) {
                                        showToast(Str_NoSpacesAllowed);
                                    }
                                    isRegister ? setRegisterAccount(cleaned) : setAccount(cleaned);
                                }}
                            />

                            <LoginInput
                                style={{ marginTop: 12 }}
                                label={Str_Psd}
                                placeholder={Str_InputPsd}
                                editable={!busy}
                                text={isRegister ? registerPsd : psd}
                                source={<PsdIcon />}
                                onChangeText={isRegister ? setRegisterPsd : setPsd}
                                keyboardType={isIOS ? "ascii-capable" : "default"}
                                secureTextEntry={!showPassword}
                                rightIcon={
                                    <Pressable onPress={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <DisplayleIcon /> : <HideIcon />}
                                    </Pressable>
                                }
                            />
                            {isRegister &&
                                (accountType === "username" ? (
                                    <LoginInput
                                        label={Str_ConfirmPsd}
                                        style={{ marginTop: 12 }}
                                        placeholder={Str_InputPsdAgain} // "请再次输入密码"
                                        text={confirmPwd}
                                        onChangeText={setConfirmPwd}
                                        keyboardType={isIOS ? "ascii-capable" : "default"}
                                        secureTextEntry={!showPassword}
                                        source={<PsdIcon />}
                                    />
                                ) : (
                                    <LoginInput
                                        label={Str_Code}
                                        style={{ marginTop: 12 }}
                                        placeholder={Str_InputCode} // "请输入验证码"
                                        text={code}
                                        onChangeText={setCode}
                                        keyboardType="numeric"
                                        source={<SafetyIcon />}
                                        rightIcon={
                                            <Pressable onPress={() => registerSendCode()}>
                                                <Text style={{ color: color_main }}>{sendText}</Text>
                                            </Pressable>
                                        }
                                    />
                                ))}

                            {!isRegister && (
                                <View
                                    style={{
                                        width: "100%",
                                        flexDirection: "row-reverse",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: 6,
                                    }}>
                                    <Pressable onPress={ForgetPsd}>
                                        <Text style={{ fontSize: 14, color: Color71717A, fontWeight: "400", fontFamily: "" }}>
                                            {Str_ForgotPsd}
                                        </Text>
                                    </Pressable>
                                </View>
                            )}
                            <DebounceButton
                                disabled={busy}
                                debounceTime={800}
                                onPress={busy ? undefined : Login}
                                style={[styles.ctaPressable, busy && { opacity: 0.6 }]}
                            >
                                <Text style={[styles.ctaText]}>{isRegister ? Str_Register : Str_LoginRegister}</Text>
                            </DebounceButton>
                        </View>
                        {/*登录注册按钮*/}

                        <NickGuideModal
                            visible={nickGuideVisible}
                            onClose={() => {
                                setNickGuideVisible(false);
                                setBusy(false);
                            }}
                            doNext={loginSuc}
                        />
                    </View>
                    <Checkbox
                        ref={checkBoxRef}
                        style={{ marginBottom: 30, marginTop: 10 }}
                        texts={[
                            {
                                text: Str_ReadAgreed,
                                onClick: () => {
                                    if (checkBoxRef.current) {
                                        const isChecked = checkBoxRef.current.isChecked;
                                        checkBoxRef.current.changeChecked(!isChecked);
                                    }
                                },
                            },
                            { text: Str_UserAgreement, isHighlight: true, onClick: openAgreement },
                            {
                                text: Str_And,
                                onClick: () => {
                                    if (checkBoxRef.current) {
                                        const isChecked = checkBoxRef.current.isChecked;
                                        checkBoxRef.current.changeChecked(!isChecked);
                                    }
                                },
                            },
                            { text: Str_PrivacyPolicy, isHighlight: true, onClick: openPrivacyPolicy },
                        ]}
                    />
                </View>
            </View>

            <View style={styles.back}>
                <Pressable
                    onPress={() => {
                        if (busy) return;

                        if (isAddAccount === true) {
                            navigation.goBack();
                        } else {
                            navigation.replace("ServiceNumber", { vcode: vcode });
                        }
                    }}
                    style={{
                        backgroundColor: color_main,
                        borderRadius: 20,
                        paddingHorizontal: 8,
                        justifyContent: "center",
                        height: 28,
                    }}
                >
                    <Text
                        style={{
                            fontSize: 14,
                            color: white,
                            fontWeight: "400",
                            fontFamily: "",
                            textAlign: "center",
                        }}
                    >
                        {vcode}
                    </Text>
                </Pressable>
            </View>
            <ChangeLanguageModal visible={langVisible} close={() => setLangVisible(false)} />
            {!(isAddAccount && isAddAccount) && (
                <View style={{ flexDirection: "row", position: "absolute", end: 16, top: insets.top + 20 }}>
                    <Pressable style={{}} onPress={() => setLangVisible(true)}>
                        <Network fill={color_main} width={30} height={30} />
                    </Pressable>
                </View>
            )}
            {busy && (
                <View style={styles.busyMask} pointerEvents="auto">
                    <ActivityIndicator size="large" />
                </View>
            )}

            <BehavioralVerifyModal
                visible={isVerifyModalShow}
                onResult={(isSuccess, token) => {
                    setIsVerifyModalShow(false)
                    onBehavioralVerifyBlack.current?.(isSuccess, token)
                }}
            />
        </View>
    );
};
const styles = StyleSheet.create({
    // Web 优化：容器样式
    container: {
        flex: 1,
    },
    // Web 优化：内容包装器，限制最大宽度并居中
    contentWrapper: {
        ...(Platform.OS === 'web' && {
            maxWidth: 500,
            alignSelf: 'center',
            width: '100%',
        }),
    },
    // Web 优化：内容容器
    contentContainer: {
        ...(Platform.OS === 'web' && {
            maxWidth: 500,
            width: '100%',
            minHeight: 0, // 允许内容收缩
        }),
    },
    // Web 优化：表单容器（通过全局 CSS 处理阴影）
    formContainer: {},
    // Web 优化：标签页容器
    tabContainer: {
        ...(Platform.OS === 'web' && {
            maxWidth: 400,
            alignSelf: 'center',
        }),
    },
    busyMask: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: "rgba(0,0,0,0.2)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
    },
    tabText: {
        fontSize: 16,
        fontWeight: "600",
        fontFamily: "",
        ...(Platform.OS === 'web' && {
            cursor: 'pointer',
            userSelect: 'none',
        }),
    },
    image: {
        width: "100%",
        height: "100%",
        position: "absolute",
    },
    back: {
        position: "absolute",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        top: 50,
        width: "100%",
    },
    content: {
        position: "absolute",
        start: 0,
        end: 0,
        bottom: 0,
    },
    imageIndicator: {
        position: "absolute",
        bottom: 2,
        width: 42,
        height: 9.5,
        backgroundColor: color_main,
        borderRadius: 15,
    },
    tabItemContainer: {
        marginStart: 26,
    },
    register: {
        color: color_main,
        fontSize: 16,
        padding: 10,
        marginTop: 12,
    },

    ctaPressable: {
        alignSelf: "center",
        marginTop: 20,
        alignItems: "center",
        backgroundColor: Color43C6A7,
        borderRadius: 10,
        width: 325,
        height: 50,
        marginBottom: 20,
        ...(Platform.OS === 'web' && {
            cursor: 'pointer',
            userSelect: 'none',
            transition: 'opacity 0.2s',
            ':hover': {
                opacity: 0.9,
            },
        }),
    },
    ctaText: {
        marginTop: 14,
        marginBottom: 14,
        alignSelf: "center",
        color: white,
        fontSize: 16,
        fontWeight: "400",
        fontFamily: "",
        textAlign: "center",
    },
});
